import { DataSourceType } from "@coeff/api";
import { Avatar, AvatarProps } from "antd";
import * as React from "react";
import styled from "styled-components";

import {
  ActiveCampaign,
  AddCircle,
  Airtable,
  Amplitude,
  Asana,
  Basecamp,
  Bigin,
  BigQuery,
  BrowserAgentIcon,
  Calendly,
  Coda,
  Chargebee,
  Chargify,
  ClickUp,
  Clockify,
  CoefficientImport,
  CSV,
  CustomAPI,
  Etsy,
  Excel,
  Expensify,
  Facebook,
  Freshdesk,
  Gong,
  GoogleAds,
  GoogleAnalytics,
  GoogleAnalytics4,
  GoogleCalender,
  AmazonSellerCentral,
  Airwallex,
  Statsig,
  ModernTreasury,
  RudderStack,
  BrightData,
  Vwo,
  Partnerize,
  Rillet,
  Trolley,
  Scalefusion,
  Baremetrics,
  Todoist,
  Workable,
  Plausible,
  Apify,
  DataScope,
  Gorgias,
  Everhour,
  ExchangeRates,
  FastBill,
  GlassFrog,
  Hubplanner,
  Katana,
  MyHours,
  Railz,
  Tellent,
  SimFin,
  Smartwaiver,
  Lokalise,
  MailerLite,
  MailerSend,
  OneSignal,
  Postmark,
  ShortIo,
  Yotpo,
  ChartMogul,
  ConfigCat,
  Pingdom,
  Retently,
  CoinMarketCap,
  Softr,
  EmailOctopus,
  Gridly,
  Mixmax,
  ReplyIo,
  LessAnnoyingCrm,
  SnovIo,
  OnePageCrm,
  Lemlist,
  GoogleDrive,
  GoogleSearchConsole,
  Gmail,
  GoogleSheet,
  Greenhouse,
  Gusto,
  Harvest,
  HubSpot,
  Instagram,
  Intercom,
  Jira,
  Jotform,
  Klaviyo,
  Lever,
  LinkedIn,
  Looker,
  Mailchimp,
  Marketo,
  Microsoft,
  MongoDB,
  MSSQL,
  MySQL,
  NetflixQuiver,
  Netsuite,
  Notion,
  OneDrive,
  Egnyte,
  Box,
  OpenAI,
  Outreach,
  Paymo,
  Pinterest,
  Motherduck,
  Pipedrive,
  Podio,
  Aurora,
  CloudSql,
  Neon,
  Supabase,
  Clickhouse,
  Azure,
  Timescaledb,
  Postgres,
  Quickbooks,
  QUORA_ADS,
  Razorpay,
  RedditAds,
  Redshift,
  Salesforce,
  Sendgrid,
  Shopify,
  Slack,
  Smartsheet,
  Snowflake,
  Square,
  Stripe,
  SurveyMonkey,
  Tableau,
  TableIcon,
  Trello,
  Typeform,
  Xero,
  YouTube,
  Zendesk,
  Zohobooks,
  Zoom,
  Webflow,
  ZohoCrm,
  Salesloft,
  WordPress,
  WooCommerce,
  BigCommerce,
  Smartlead,
  Affinity,
  Shiprocket,
  ArrowFlightSQL,
  Databricks,
  Rippling,
  SnapshotLogo,
  Apollo,
  Sage,
  WebScraper,
  AwsBilling,
  GoogleClassroom,
  Twilio,
  SharePoint,
  Campfire,
  Kit,
  Insightly,
  Freshsales,
  CloseCRM,
  Mode,
  Monday,
  Mixpanel,
  KoboToolbox,
  TogglTrack,
  SmartSuite,
  Odoo,
  Linear,
  Metabase,
  Teamwork,
  CatsAts,
  Freshservice,
  Hive,
  Aircall,
  NimbleCrm,
  Drip,
  Paddle,
  AgileCrm,
  Checkout,
  CapsuleCrm,
  Nutshell,
  Pipeliner,
  Salesflare,
  VtigerCrm,
  Bitbucket,
  GitLabAi,
  HelpScoutAi,
  FrontAi,
  WrikeAi,
  BambooHr,
  DeelAi,
  ConfluenceAi,
  Teamleader,
  MiroAi,
  OmnisendAi,
  AttioAi,
  CreatioAi,
  FreeAgentAi,
  MoneybirdAi,
  AcceloAi,
  ApplicantstackAi,
  AlowareAi,
  StackbyAi,
  FloatAi,
  ClickhouseAi,
  AppsflyerAi,
  MariaDB,
  LaunchDarkly,
  PostHog,
  Dovetail,
  Shipstation,
  Mindbody,
  Groww,
} from "./Icons";
import { Loader } from "./Loader";

type ImportIconType =
  | DataSourceType
  | "coefficient"
  | "plus"
  | "loading"
  | "gpt_copilot"
  | "slack"
  | "snapshot"
  | undefined;

type ImportTypeIconProps = AvatarProps & {
  type: ImportIconType;
  size?: number;
};

const StyledAvatar = styled(Avatar)<{ size?: AvatarProps["size"] }>`
  background: none;

  svg {
    width: ${props => (typeof props.size === "number" ? props.size : 40)}px;
    height: ${props => (typeof props.size === "number" ? props.size : 40)}px;
  }
`;
export const ImportTypeIcon: React.FC<ImportTypeIconProps> = ({ type, size }) => {
  return (
    <StyledAvatar
      className="dataSourceTypeIcon"
      size={size ?? "large"}
      icon={getImportIcon(type, size)}
    />
  );
};

export const getImportIcon = (type: ImportIconType, size?: number) => {
  switch (type) {
    case "airtable":
      return <Airtable />;
    case "amplitude":
      return <Amplitude />;
    case "bigquery":
      return <BigQuery />;
    case "chargebee":
    case "chargebee_ai":
      return <Chargebee />;
    case "chargify":
      return <Chargify />;
    case "coefficient":
      return <CoefficientImport />;
    case "csv":
      return <CSV />;
    case "gong":
      return <Gong />;
    case "google_analytics":
      return <GoogleAnalytics />;
    case "google_drive":
      return <GoogleDrive />;
    case "google_sheets":
      return <GoogleSheet />;
    case "excel":
      return <Excel />;
    case "hubspot":
      return <HubSpot />;
    case "instagram_insights":
      return <Instagram />;
    case "jira_ai":
    case "jira":
      return <Jira />;
    case "klaviyo":
      return <Klaviyo />;
    case "linkedin":
    case "linkedin_ads":
    case "linkedin_pages":
      return <LinkedIn />;
    case "looker":
      return <Looker />;
    case "mailchimp":
      return <Mailchimp />;
    case "marketo":
      return <Marketo />;
    case "microsoft_ads":
      return <Microsoft />;
    case "mongodb":
      return <MongoDB />;
    case "mysql":
      return <MySQL />;
    case "mssql":
      return <MSSQL />;
    case "netflix_quiver":
      return <NetflixQuiver />;
    case "netsuite":
      return <Netsuite />;
    case "netsuite_crx":
      return <Netsuite />;
    case "one_drive":
      return <OneDrive />;
    case "sharepoint_lists":
      return <SharePoint />;
    case "egnyte":
      return <Egnyte />;
    case "box":
      return <Box />;
    case "outreach":
    case "outreach_ai":
      return <Outreach />;
    case "motherduck":
      return <Motherduck />;
    case "pipedrive":
      return <Pipedrive />;
    case "postgres":
      return <Postgres />;
    case "aurora_postgres":
    case "aurora_mysql":
      return <Aurora />;
    case "cloud_sql_postgres":
    case "cloud_sql_mysql":
      return <CloudSql />;
    case "supabase":
      return <Supabase />;
    case "neon":
      return <Neon />;
    case "timescaledb":
      return <Timescaledb />;
    case "azure_postgres":
    case "azure_mysql":
    case "azure_sql":
      return <Azure />;
    case "clickhouse":
      return <Clickhouse />;
    case "quickbooks":
      return <Quickbooks />;
    case "redshift":
      return <Redshift />;
    case "salesforce":
      return <Salesforce />;
    case "sendgrid":
    case "sendgrid_ai":
      return <Sendgrid />;
    case "shopify":
      return <Shopify />;
    case "snowflake":
      return <Snowflake />;
    case "stripe":
    case "stripe_ai":
      return <Stripe />;
    case "tableau":
      return <Tableau />;
    case "zendesk":
      return <Zendesk />;
    case "google_analytics_4":
      return <GoogleAnalytics4 />;
    case "facebook_ads":
    case "facebook_insights":
      return <Facebook />;
    case "google_search_console":
      return <GoogleSearchConsole />;
    case "gmail":
      return <Gmail />;
    case "google_ads":
      return <GoogleAds />;
    case "notion":
      return <Notion />;
    case "gpt_copilot":
      return <OpenAI />;
    case "cloud_table":
      return <TableIcon />;
    case "greenhouse":
    case "greenhouse_ai":
      return <Greenhouse />;
    case "gusto":
      return <Gusto />;
    case "xero":
      return <Xero />;
    case "browser_agent":
      return <BrowserAgentIcon />;
    case "custom_api":
    case "any_api_agent":
      return <CustomAPI />;
    case "slack":
      return <Slack />;
    case "youtube_analytics":
      return <YouTube />;
    case "asana":
      return <Asana />;
    case "razorpay":
      return <Razorpay />;
    case "clickup":
    case "clickup_ai":
      return <ClickUp />;
    case "typeform":
    case "typeform_ai":
      return <Typeform />;
    case "harvest":
      return <Harvest />;
    case "freshdesk":
    case "freshdesk_ai":
      return <Freshdesk />;
    case "paymo":
      return <Paymo />;
    case "google_calendar":
      return <GoogleCalender />;
    case "amazon_seller_central":
      return <AmazonSellerCentral />;
    case "trello":
    case "trello_ai":
      return <Trello />;
    case "calendly":
      return <Calendly />;
    case "smartsheet":
    case "smartsheet_ai":
      return <Smartsheet />;
    case "reddit_ads":
      return <RedditAds />;
    case "surveymonkey":
      return <SurveyMonkey />;
    case "quora_ads":
      return <QUORA_ADS />;
    case "podio":
    case "podio_ai":
      return <Podio />;
    case "intercom":
      return <Intercom />;
    case "etsy":
      return <Etsy />;
    case "pinterest_ads":
      return <Pinterest />;
    case "active_campaign":
      return <ActiveCampaign />;
    case "basecamp":
    case "basecamp_ai":
      return <Basecamp />;
    case "jotform":
    case "jotform_ai":
      return <Jotform />;
    case "zohobooks":
    case "zohobooks_ai":
      return <Zohobooks />;
    case "coda":
    case "coda_ai":
      return <Coda />;
    case "square":
    case "square_ai":
      return <Square />;
    case "expensify_ai":
      return <Expensify />;
    case "zoom":
      return <Zoom />;
    case "webflow":
      return <Webflow />;
    case "bigin":
    case "bigin_ai":
      return <Bigin />;
    case "zoho_crm":
    case "zoho_crm_ai":
      return <ZohoCrm />;
    case "lever":
      return <Lever />;
    case "salesloft":
      return <Salesloft />;
    case "wordpress":
      return <WordPress />;
    case "woo_commerce":
      return <WooCommerce />;
    case "bigcommerce":
      return <BigCommerce />;
    case "smartlead":
      return <Smartlead />;
    case "affinity":
      return <Affinity />;
    case "shiprocket":
      return <Shiprocket />;
    case "databricks":
      return <Databricks />;
    case "arrow_flight_sql":
      return <ArrowFlightSQL />;
    case "rippling":
      return <Rippling />;
    case "snapshot":
      return <SnapshotLogo />;
    case "apollo":
    case "apollo_ai":
      return <Apollo />;
    case "sage":
      return <Sage />;
    case "web_scraper":
      return <WebScraper />;
    case "aws_billing":
      return <AwsBilling />;
    case "google_classroom":
      return <GoogleClassroom />;
    case "twilio_ai":
      return <Twilio />;
    case "campfire":
      return <Campfire />;
    case "rillet":
      return <Rillet />;
    case "kit_ai":
      return <Kit />;
    case "insightly_ai":
      return <Insightly />;
    case "freshsales_ai":
      return <Freshsales />;
    case "close_ai":
      return <CloseCRM />;
    case "xero_ai":
      return <Xero />;
    case "mode_ai":
      return <Mode />;
    case "monday_ai":
      return <Monday />;
    case "mixpanel_ai":
      return <Mixpanel />;
    case "clockify_ai":
      return <Clockify />;
    case "kobotoolbox_ai":
      return <KoboToolbox />;
    case "toggl_track_ai":
      return <TogglTrack />;
    case "smartsuite_ai":
      return <SmartSuite />;
    case "odoo_ai":
      return <Odoo />;
    case "linear_ai":
      return <Linear />;
    case "klaviyo_ai":
      return <Klaviyo />;
    case "razorpay_ai":
      return <Razorpay />;
    case "paymo_ai":
      return <Paymo />;
    case "active_campaign_ai":
      return <ActiveCampaign />;
    case "wordpress_ai":
      return <WordPress />;
    case "woo_commerce_ai":
      return <WooCommerce />;
    case "smartlead_ai":
      return <Smartlead />;
    case "shiprocket_ai":
      return <Shiprocket />;
    case "rippling_ai":
      return <Rippling />;
    case "harvest_ai":
      return <Harvest />;
    case "calendly_ai":
      return <Calendly />;
    case "metabase_ai":
      return <Metabase />;
    case "teamwork_ai":
      return <Teamwork />;
    case "cats_ats_ai":
      return <CatsAts />;
    case "nutshell_ai":
      return <Nutshell />;
    case "pipeliner_ai":
      return <Pipeliner />;
    case "salesflare_ai":
      return <Salesflare />;
    case "vtiger_crm_ai":
      return <VtigerCrm />;
    case "freshservice_ai":
      return <Freshservice />;
    case "hive_ai":
      return <Hive />;
    case "aircall_ai":
      return <Aircall />;
    case "nimble_crm_ai":
      return <NimbleCrm />;
    case "drip_ai":
      return <Drip />;
    case "paddle_ai":
      return <Paddle />;
    case "agile_crm_ai":
      return <AgileCrm />;
    case "checkout_ai":
      return <Checkout />;
    case "capsule_ai":
      return <CapsuleCrm />;
    case "bitbucket_ai":
      return <Bitbucket />;
    case "gitlab_ai":
      return <GitLabAi />;
    case "helpscout_ai":
      return <HelpScoutAi />;
    case "front_ai":
      return <FrontAi />;
    case "wrike_ai":
      return <WrikeAi />;
    case "bamboohr_ai":
      return <BambooHr />;
    case "deel_ai":
      return <DeelAi />;
    case "confluence_ai":
      return <ConfluenceAi />;
    case "teamleader_ai":
      return <Teamleader />;
    case "miro_ai":
      return <MiroAi />;
    case "omnisend_ai":
      return <OmnisendAi />;
    case "attio_ai":
      return <AttioAi />;
    case "creatio_ai":
      return <CreatioAi />;
    case "freeagent_ai":
      return <FreeAgentAi />;
    case "moneybird_ai":
      return <MoneybirdAi />;
    case "accelo_ai":
      return <AcceloAi />;
    case "applicantstack_ai":
      return <ApplicantstackAi />;
    case "aloware_ai":
      return <AlowareAi />;
    case "stackby_ai":
      return <StackbyAi />;
    case "float_ai":
      return <FloatAi />;
    case "clickhouse_ai":
      return <ClickhouseAi />;
    case "appsflyer_ai":
      return <AppsflyerAi />;
    case "mariadb_ai":
      return <MariaDB />;
    case "launchdarkly_ai":
      return <LaunchDarkly />;
    case "posthog_ai":
      return <PostHog />;
    case "dovetail_ai":
      return <Dovetail />;
    case "shipstation_ai":
      return <Shipstation />;
    case "mindbody_ai":
      return <Mindbody />;
    case "groww_ai":
      return <Groww />;
    case "amazon_seller_central_ai":
      return <AmazonSellerCentral />;
    case "airwallex_ai":
      return <Airwallex />;
    case "statsig_ai":
      return <Statsig />;
    case "modern_treasury_ai":
      return <ModernTreasury />;
    case "rudderstack_ai":
      return <RudderStack />;
    case "bright_data_ai":
      return <BrightData />;
    case "vwo_ai":
      return <Vwo />;
    case "partnerize_ai":
      return <Partnerize />;
    case "rillet_ai":
      return <Rillet />;
    case "trolley_ai":
      return <Trolley />;
    case "scalefusion_ai":
      return <Scalefusion />;
    case "baremetrics_ai":
      return <Baremetrics />;
    case "todoist_ai":
      return <Todoist />;
    case "workable_ai":
      return <Workable />;
    case "plausible_ai":
      return <Plausible />;
    case "apify_ai":
      return <Apify />;
    case "datascope_ai":
      return <DataScope />;
    case "gorgias_ai":
      return <Gorgias />;
    case "everhour_ai":
      return <Everhour />;
    case "exchangerates_ai":
      return <ExchangeRates />;
    case "fastbill_ai":
      return <FastBill />;
    case "glassfrog_ai":
      return <GlassFrog />;
    case "resource_flow_hubplanner_ai":
      return <Hubplanner />;
    case "katana_ai":
      return <Katana />;
    case "myhours_ai":
      return <MyHours />;
    case "fis_railz_ai":
      return <Railz />;
    case "tellent_hris_ai":
      return <Tellent />;
    case "simfin_ai":
      return <SimFin />;
    case "smartwaiver_ai":
      return <Smartwaiver />;
    case "lokalise_ai":
      return <Lokalise />;
    case "mailerlite_ai":
      return <MailerLite />;
    case "mailersend_ai":
      return <MailerSend />;
    case "onesignal_ai":
      return <OneSignal />;
    case "postmark_ai":
      return <Postmark />;
    case "short_io_ai":
      return <ShortIo />;
    case "yotpo_ai":
      return <Yotpo />;
    case "chartmogul_ai":
      return <ChartMogul />;
    case "configcat_ai":
      return <ConfigCat />;
    case "pingdom_ai":
      return <Pingdom />;
    case "retently_ai":
      return <Retently />;
    case "coinmarketcap_ai":
      return <CoinMarketCap />;
    case "softr_io_ai":
      return <Softr />;
    case "emailoctopus_ai":
      return <EmailOctopus />;
    case "gridly_ai":
      return <Gridly />;
    case "mixmax_ai":
      return <Mixmax />;
    case "reply_io_ai":
      return <ReplyIo />;
    case "less_annoying_crm_ai":
      return <LessAnnoyingCrm />;
    case "snov_io_ai":
      return <SnovIo />;
    case "onepagecrm_ai":
      return <OnePageCrm />;
    case "lemlist_ai":
      return <Lemlist />;
    case "loading":
      return <Loader style={{ width: size ?? 40 }} />;
    case "plus":
    default:
      return <AddCircle />;
  }
};
